/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import { UseTooltipProps, UseTooltipReturn } from './types';

const defaultLocalization: UseTooltipProps['localization'] = {
  copiedToClipboard: 'Kopierat',
};

export const useTooltip = ({
  tooltip,
  enableClickToCopy = false,
  localization = defaultLocalization,
}: UseTooltipProps): UseTooltipReturn => {
  const [displayTooltipText, setDisplayTooltipText] = useState<string>(tooltip ?? '');
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const [lockTooltip, setLockTooltip] = useState<boolean>(false);

  const handleMouseEnter = () => {
    if (!lockTooltip) {
      setTooltipOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!lockTooltip) {
      setTooltipOpen(false);
    }
  };

  const handleCopy = (copyContent: string) => {
    if (enableClickToCopy) {
      navigator.clipboard.writeText(copyContent);
      setDisplayTooltipText(localization.copiedToClipboard);
      setTooltipOpen(true);
      setLockTooltip(true);

      setTimeout(() => {
        setTooltipOpen(false);
        setLockTooltip(false);
        setTimeout(() => {
          setDisplayTooltipText(tooltip ?? '');
        }, 200);
      }, 4000);
    }
  };

  return {
    tooltipText: displayTooltipText,
    tooltipOpen,
    handleMouseEnter,
    handleMouseLeave,
    handleCopy,
  };
};
